import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { apiOpenAlt } from '@/api/apiOpenAlt';

export default function ApiUsagePage() {
  const { user } = useAuth();
  const [usage, setUsage] = useState<{ total: number; used: number; remaining: number } | null>(null);
  const [apiKey, setApiKey] = useState('');
  const [userId, setUserId] = useState(user?.userId || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleFetchUsage = async () => {
    if (!apiKey.trim()) {
      setError('API Key를 입력하세요.');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const data = await apiOpenAlt.getUsage(apiKey.trim());
      setUsage(data);
    } catch (e: any) {
      setError(e.response?.data?.message || 'API 사용량 조회에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto py-8">
      <Card>
        <CardHeader>
          <CardTitle>API 사용 이력/쿼터</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-2">
            <label className="block text-sm font-medium mb-1">회원 ID</label>
            <input
              type="text"
              className="border rounded px-2 py-1 w-full text-sm"
              value={user?.userRole === 'SUPER_ADMIN' ? userId : user?.userId || ''}
              onChange={e => {
                if (user?.userRole === 'SUPER_ADMIN') setUserId(e.target.value);
              }}
              disabled={user?.userRole !== 'SUPER_ADMIN'}
            />
            <label className="block text-sm font-medium mt-4 mb-1">API Key</label>
            <input
              type="text"
              className="border rounded px-2 py-1 w-full text-sm"
              placeholder="API Key를 입력하세요"
              value={apiKey}
              onChange={e => setApiKey(e.target.value)}
              disabled={loading}
            />
            <Button onClick={handleFetchUsage} disabled={loading} className="w-full">
              {loading ? '조회 중...' : 'API 사용량/쿼터 조회'}
            </Button>
          </div>
          {usage && (
            <div className="bg-gray-100 rounded p-3 text-sm">
              <div>총 쿼터: <b>{usage.total}</b></div>
              <div>사용: <b>{usage.used}</b></div>
              <div>남은 쿼터: <b>{usage.remaining}</b></div>
            </div>
          )}
          {error && <div className="text-red-600 text-sm">{error}</div>}
        </CardContent>
      </Card>
    </div>
  );
}
